import React, {useEffect, useState} from 'react';
import {PanelMenu} from 'primereact/panelmenu';
import {MenuItem} from "primereact/menuitem";

type Properties = {
    onChange: (menuId: string, menuName: string) => void,
    topics: Array<MenuDescriptor>
}

export type MenuDescriptor = {
    code: string,
    path: Array<string>,
    name: string
}

type InternalMenuItem = {
    children?: any,
    name?: string,
    code?: string
}

function MainLeftMenu(props: Properties) {
    let root: InternalMenuItem = {
        children: {}
    }

    props.topics.forEach(md => {
        function getCurrentMenuItem(md: MenuDescriptor): any {
            let parentItem: InternalMenuItem = root
            md.path.forEach(cn => parentItem = parentItem.children[cn])
            if (!parentItem.children) {
                parentItem["children"] = {}
            }
            parentItem.children[md.code] = {}
            return parentItem.children[md.code]
        }

        let menuItem = getCurrentMenuItem(md)
        menuItem.name = md.name
        menuItem.code = md.code
    })

    function createItems(items: Array<InternalMenuItem>): Array<MenuItem> {
        return items.map(item => {
            let res: any = {
                key: item.code,
                label: item.name,
                url: "/docs#" + item.code
            }
            if (item.children) {
                res["items"] = createItems(Object.values(item.children))
            }
            return res as MenuItem
        })
    }

    const menuItems: Array<MenuItem> = createItems(Object.values(root.children))

    const [expandedKeys, setExpandedKeys] = useState<any>({});

    const expandNode = (node: any) => {
        if (node.items && node.items.length) {
            expandedKeys[node.key] = true;
            node.items.forEach(expandNode);
        }
    };

    useEffect(() => {
        expandNode(menuItems[0])
        window.addEventListener("hashchange", function (e) {
            let menuDescriptors = props.topics
                .filter((md) => md.code == window.location.hash.substring(1))[0];
            console.log(menuDescriptors)
            props.onChange(window.location.hash, menuDescriptors.name)
        });
    }, []);

    return (
        <div className={"scroll-vertical"}>
            <div className="card flex flex-column align-items-center gap-3">
                <PanelMenu model={menuItems}
                           expandedKeys={expandedKeys}
                           onExpandedKeysChange={setExpandedKeys}
                           multiple={true}
                           className="w-full md:w-10rem"
                />
            </div>
        </div>
    )
}


export default MainLeftMenu;
        